import { isNumber } from 'yankees-react-utils';

const roundToNearestTwentieth = (value) => {
    if (!isNumber(value)) return null;

    const floatVal = parseFloat(value);
    const adjustment = floatVal % 0.05;
    return adjustment >= 0.025 ? floatVal + (0.05 - adjustment) : floatVal - adjustment;
};

export const roundPitcherAvgTimes = (avg) => {
    const fields = [
        'r1min', 'r1max', 'r2min', 'r2max',
        'r1fbmin', 'r1fbmax', 'r2fbmin', 'r2fbmax',
        'r1bbmin', 'r1bbmax', 'r2bbmin', 'r2bbmax',
        'r1chsplmin', 'r1chsplmax', 'r2chsplmin', 'r2chsplmax',
    ];
    return fields.reduce((acc, field) => ({
        ...acc,
        [field]: roundToNearestTwentieth(acc[field]),
    }), { ...avg });
};

export const buildStealingAgainstTimeCharts = (translate, pitchertimes, settimes) => {
    const pitcherTimes = (pitchertimes || []).reduce((acc, t) => {
        if (!acc[t.playerid]) acc[t.playerid] = [];
        if (t.bcbefore === 1 && t.pitchtype == null && isNumber(t.pitchertime)) {
            acc[t.playerid].push(t);
        }
        return acc;
    }, {});

    const setTimes = (settimes || []).reduce((acc, t) => {
        if (!acc[t.playerid]) acc[t.playerid] = [];
        if (t.bcbefore === 1 && t.pitchtype == null && isNumber(t.settime)) {
            acc[t.playerid].push(t);
        }
        return acc;
    }, {});

    const buildChartConfig = (title, timesByPlayer) => Object.keys(timesByPlayer)
        .filter((id) => timesByPlayer[id].length)
        .reduce((acc, id) => ({
            ...acc,
            [id]: {
                chart: {
                    width: 300,
                    height: 100,
                },
                legend: {
                    enabled: false,
                },
                xAxis: {
                    softMin: 1,
                    softMax: 2,
                    labels: {
                        format: '{value}s',
                    },
                },
                yAxis: {
                    title: { text: undefined },
                },
                title: {
                    text: title,
                    style: { fontSize: '10px' },
                },
                series: [{
                    type: 'column',
                    pointPadding: 0,
                    groupPadding: 0,
                    borderWidth: 0,
                    shadow: false,
                    data: timesByPlayer[id].map((t) => ({
                        x: t.pitchertime || t.settime,
                        y: t.numtimes,
                        playerid: id,
                        name: `${t.pitchertime || t.settime} ${translate('common.abbr-seconds')} (${t.numtimes})`,
                    })),
                    dataLabels: {
                        enabled: false,
                    },
                }],
            },
        }), {});

    return {
        pitchTimesChartConfig: buildChartConfig(
            `${translate('sections.opponent.team.time-to-plate')} (${translate('common.abbr-seconds')}.)`,
            pitcherTimes,
        ),
        setTimesChartConfig: buildChartConfig(
            `${translate('sections.opponent.team.set-time')} (${translate('common.abbr-seconds')}.)`,
            setTimes,
        ),
    };
};
